export default __webpack_public_path__ + "static/media/quick_play_illustration_3.bc82d942.png";